import { withDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import type { ServiceFactoryOpts } from '@wix/services-manager/types'
import {
	FedopsLoggerDefinition as definition,
	IFedopsLoggerDefinition,
	IFedopsLoggerService,
	IFedopsLoggerServiceConfig,
} from '@wix/viewer-service-fedops-logger/definition'
import { FedopsLoggerService as impl } from '@wix/viewer-service-fedops-logger/implementations'

export const fedopsLoggerService = withDependencies(
	[],
	(): ServiceProvider<
		IFedopsLoggerDefinition,
		(opts: ServiceFactoryOpts<IFedopsLoggerServiceConfig>) => IFedopsLoggerService
	> => {
		return {
			definition,
			impl,
			config: {},
			platformConfig: {},
		}
	}
)
